export default __webpack_public_path__ + "static/media/nobg-pic.21fd9a86.png";